import React from "react";

const KPIWidgets = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6">

      <div className="bg-gray-800 p-4 rounded-lg border border-gray-700">
        <div className="text-xs text-gray-400">Active Sprint</div>
        <div className="text-xl font-bold text-cyan-400">{stats.activeSprint}</div>
      </div>

      <div className="bg-gray-800 p-4 rounded-lg border border-gray-700">
        <div className="text-xs text-gray-400">Velocity</div>
        <div className="text-xl font-bold text-green-400">{stats.velocity}</div>
      </div>

      <div className="bg-gray-800 p-4 rounded-lg border border-gray-700">
        <div className="text-xs text-gray-400">Completion</div>
        <div className="text-xl font-bold text-purple-400">{stats.completion}%</div>
      </div>

      <div className="bg-gray-800 p-4 rounded-lg border border-gray-700">
        <div className="text-xs text-gray-400">Open Issues</div>
        <div className="text-xl font-bold text-red-400">{stats.issues}</div>
      </div>

    </div>
  );
};

export default KPIWidgets;